import { render, staticRenderFns } from "./TasklistToolbarActions.vue?vue&type=template&id=2a10877c"
import script from "./TasklistToolbarActions.vue?vue&type=script&lang=js"
export * from "./TasklistToolbarActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports